module.exports = "build/assets/periwinkleWaveLarge.6bf53755.png";